import { NavigationAreaNormalizedTemplateConfigs } from '@flowx/designer/shared/api/node.api'
import { Area } from '@flowx/designer/shared/entities/nav-area.entity'
import { NormalizedTemplateConfig } from '@flowx/shared/interfaces'

// The UI template an area renders as; the UI designer documents the area on it.
export const areaRootTemplateConfig = (
  navigationTree: NavigationAreaNormalizedTemplateConfigs,
  areaId: Area['id']
): NormalizedTemplateConfig | undefined =>
  Object.values(navigationTree[areaId] ?? {}).find(({ parentReferenceId }) => !parentReferenceId)
